import React from "react";
import { STORED_BOOLEAN_TRUE } from "./personDetailValues";

function usePersistedBoolean(key: string, defaultValue: boolean) {
  const [value, setValue] = React.useState<boolean>(() => {
    const saved = localStorage.getItem(key);
    return saved === null ? defaultValue : saved === STORED_BOOLEAN_TRUE;
  });

  React.useEffect(() => {
    localStorage.setItem(key, String(value));
  }, [key, value]);

  return [value, setValue] as const;
}

export function usePersonDetailDisplayPreferences(accountId?: string | null) {
  const uiAccountId = accountId || "default";
  const contractsKey = React.useMemo(() => `persons-detail-contracts-showHistorical-${uiAccountId}`, [uiAccountId]);
  const walletsKey = React.useMemo(() => `persons-detail-wallets-showHistorical-${uiAccountId}`, [uiAccountId]);
  const articleSalesKey = React.useMemo(() => `persons-detail-articleSales-showHistorical-${uiAccountId}`, [uiAccountId]);

  const [showHistoricalContracts, setShowHistoricalContracts] = usePersistedBoolean(contractsKey, true);
  const [showHistoricalWallets, setShowHistoricalWallets] = usePersistedBoolean(walletsKey, true);
  const [showHistoricalArticleSales, setShowHistoricalArticleSales] = usePersistedBoolean(articleSalesKey, true);

  return {
    showHistoricalContracts,
    setShowHistoricalContracts,
    showHistoricalWallets,
    setShowHistoricalWallets,
    showHistoricalArticleSales,
    setShowHistoricalArticleSales
  };
}
